import {
  Component,
  inject,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalService } from '@core-app/services/modal.service';
import { SharedModule } from '@frontend-workspace/shared/src';

@Component({
  selector: 'frontend-workspace-confirm-modal',
  imports: [SharedModule],
  templateUrl: './confirm-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './confirm-modal.component.scss',
})
export class ConfirmModalComponent {
  data = inject<{
    [key: string]: unknown;
  }>(MAT_DIALOG_DATA);

  @Input() promptText = 'Are you sure?';

  public readonly modalService = inject(ModalService);
}
